class MiniCart {
  constructor(cartEndpoint) {
    this.cartEndpoint = cartEndpoint ? cartEndpoint : "/cart.js";
    this.minicart = document.querySelector("[data-minicart]");
    this.items = document.querySelector("[data-minicart-items]");
    this.item = "data-minicart-item";
    this.close = "data-minicart-close";
    this.open = "data-minicart-open";
    this.plus = "data-minicart-plus";
    this.minus = "data-minicart-minus";
    this.count = "data-minicart-count";
    this.totalCount = $('[data-minicart-totalCount]');
    this.remove = "data-minicart-remove";
    this.subtotal = document.querySelector("[data-minicart-subtotal]");
  }
  
  /* FREE GIFT POPUP */
  updateRefillPopup() {
    let check_refills = false;
    fetch(this.cartEndpoint)
      .then((resp) => resp.json())
      .then((cart) => {
        if (cart) {
          $(cart.items).each(function(index, value) {
            if ( value.id == 44423067664643 || value.id == 44423068745987 ) {
              check_refills = true;
            }
          });
          if ( cart.total_price >= 7500 & check_refills != true ) {
            $('#gift-popup-main').addClass('cc-popup--visible');
            $('#gift-popup-main').removeClass('refill-added');
          } else {
            $('#gift-popup-main').removeClass('cc-popup--visible');
            $('#gift-popup-main').addClass('refill-added');
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }
  /* END OF FREE GIFT POPUP */

  openCart(target) {
    if (this.minicart && target.hasAttribute(this.open)) {
      this.minicart.classList.add("open");
      this.minicart.classList.remove("close");
    }
  }

  closeCart(target) {
    if (this.minicart && target.hasAttribute(this.close)) {
      this.minicart.classList.remove("open");
      this.minicart.classList.add("close");
    }
  }

  updatTotalCount(total) {
    this.totalCount.html(total);
  }

  updateSubtotal(total, originalTotal) {
    if (!total) return false;
    if (this.subtotal) {
      var delElement = document.createElement('del');
      delElement.textContent = this.moneyFormat(originalTotal).replace(/\.00$/, "");
  
      var originalSubtotalSpan = document.createElement('span');
      originalSubtotalSpan.classList.add('original-subtotal');
      originalSubtotalSpan.appendChild(delElement);
  
      if (originalTotal > total) {
        this.subtotal.innerHTML = `${this.moneyFormat(total).replace(/\.00$/, "")} `;
        this.subtotal.appendChild(originalSubtotalSpan);
      } else {
        this.subtotal.innerHTML = this.moneyFormat(total).replace(/\.00$/, "");
      }
    }
  }

  updateShippingBar(total) {
    if (!total) return false;
    var get_total = total / 100;
    if ( get_total < 75 ) {
      var get_shipping_percentage = ( get_total / 75 ) * 100;
      $('.free-shipping-bar .color-line').css('width', get_shipping_percentage + '%');
      $('.shipping-bar .cart-info.progress').removeClass('hide');
      $('.shipping-bar .cart-info.success').addClass('hide');
    } else {
      $('.free-shipping-bar .color-line').css('width', '100%');
      $('.shipping-bar .cart-info.progress').addClass('hide');
      $('.shipping-bar .cart-info.success').removeClass('hide');
    }
  }

  updateCart(openCart = true) {
    let get_total_count = 0;
    let get_protection_product = $('.route-div route-protect-widget');
    let check_auto_add_prd = false;
    let trigger_variant_id = 46382097694979;
    let auto_add_variant_id = 46355848265987;
    let trigger_product_exists = false;
    
    fetch(this.cartEndpoint)
      .then((resp) => resp.json())
      .then((cart) => {
        if (cart) {
          $(cart.items).each(function(index, value) {
            if (value.variant_id == trigger_variant_id) {
              trigger_product_exists = true;
            }
            if (value.variant_id == auto_add_variant_id) {
              check_auto_add_prd = true;
            }
          });

          // Auto-add product logic
          //

          // if ( cart.total_price >= 7500 && !check_auto_add_prd ) {
          //   $.ajax({
          //     type: 'POST', 
          //     url: '/cart/add.js',
          //     dataType: 'json', 
          //     data: { quantity: 1, id: 43777167851788 },
          //     success: function() {
          //       //Minicart Update
          //       mini_cart.updateCart(true);
          //     },
          //     error: function(jqxhr, textStatus, error) {
          //       console.log("ERROR: " + textStatus + " " + error);
          //     }
          //   });
          // } 
          // else {
          //   if ( check_auto_add_prd ) {
          //     $.ajax({
          //       type: 'POST', 
          //       url: '/cart/change.js',
          //       dataType: 'json', 
          //       data: { quantity: 0, id: 43777167851788 },
          //       success: function() {
          //         //Minicart Update
          //         // mini_cart.updateCart(true);
          //       },
          //       error: function(jqxhr, textStatus, error) {
          //         console.log("ERROR: " + textStatus + " " + error);
          //       }
          //     });
          //   }
          // }
          this.updateShippingBar(cart.total_price);
          this.updateSubtotal(cart.total_price, cart.original_total_price);
          this.updatTotalCount(cart.item_count);
          let allItems = "";
          for (let item of cart.items) {
            allItems += this.cartItemHTML(item);
          }
          if (this.items) {
            this.items.innerHTML = allItems;
          }
          if (cart.items.length < 1) {
            this.isEmpty();
          } else {
            this.isFilled(openCart);
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  isFilled(openCart = true) {
    if (this.minicart) {
      this.minicart.classList.remove("empty");
      if (openCart) {
        this.minicart.classList.remove("close");
        this.minicart.classList.add("open");
      }
    }
  }

  isEmpty() {
    if (this.minicart) {
      this.minicart.classList.add("empty");
    }
  }

  removeCartItem(target) {
    if (target.hasAttribute(this.remove)) {
      const id =
        this.findAncestor(target, `[${this.item}]`) &&
        this.findAncestor(target, `[${this.item}]`).dataset["minicartItem"];
      if (id) {
        fetch("/cart/change.js", {
          method: "post",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: id,
            quantity: 0,
          }),
        })
          .then((resp) => resp.json())
          .then((cart) => {
            this.updateCart();
            // this.updateRefillPopup();
          })
          .catch((error) => {
            console.error(error);
          });
      }
    }
  }

  minusCartItem(target) {
    if (target.hasAttribute(this.minus)) {
      const id =
        this.findAncestor(target, `[${this.item}]`) &&
        this.findAncestor(target, `[${this.item}]`).dataset["minicartItem"];
      const quantityPicker = target.parentNode;
      const countElem = quantityPicker.querySelector(`[${this.count}]`);
      const newQuantity =
        countElem.textContent && parseInt(countElem.textContent) - 1;
//       if (id && newQuantity) {
        fetch("/cart/change.js", {
          method: "post",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: `quantity=${newQuantity}&id=${id}`,
        })
          .then(() => {
            this.updateCart();
            // this.updateRefillPopup();
          })
          .catch((error) => {
            console.error("Error:", error);
          });
//       }
    }
  }

  plusCartItem(target) {
    var check_auto_add_prd = false;
    if (target.hasAttribute(this.plus)) {
      const id =
        this.findAncestor(target, `[${this.item}]`) &&
        this.findAncestor(target, `[${this.item}]`).dataset["minicartItem"];

      if (id) {
        fetch("/cart/add.js", {
          method: "post",
          headers: {
            "x-requested-with": "XMLHttpRequest",
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: `id=${id}&quantity=1`,
        })
          .then((resp) => resp.json())
          .then((data) => {
            if (data.status === 422) {
            } else {
              this.updateCart();
              // this.updateRefillPopup();
            }
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }
    }
  }
  
  cartItemHTML(item) {
    function CompareAtPrice(item) {
      let comp_price = 0;
      $.ajax({
        url: '/products/' + item.handle + '.js', 
        dataType: 'json',
        async: false, 
        success: function(product){ 
          product.variants.forEach(function(variant) {
            if (variant.compare_at_price != null && variant.id == item.variant_id)
              comp_price = variant.compare_at_price;
            else
              comp_price = 0;
          });
        } 
      });
      return comp_price;
    }
    function buildProps(item) {
      if (
        !item ||
        !item.properties ||
        Object.keys(item.properties).length === 0
      )
        return "";

      let result = "";
      for (const [key, value] of Object.entries(item.properties)) {
        result += `<li>${key}: ${value}</li>`;
      }
      return result;
    }

    function buildOptions(item) {
      if (
        !item ||
        !item.options_with_values ||
        item.options_with_values.length === 0
      )
        return "";

      let result = "";
      for (let option of item.options_with_values) {
        if (option.value !== "Default Title") {
          result += `<li>${option.name}: ${option.value}</li>`;
        }
      }
      return result;
    }

    function getImage(image, size = 300) {
      if (!image) return "";
      const ext = image.match(/\.(?:jpg|gif|png)/g);
      return image.replace(ext[0], `_${size}x` + ext[0]);
    }

    function buildImage(item) {
      if (!item) return "";
      return `<img alt="" class="responsive-image__image lazyload" data-sizes="auto" src="${getImage(
        item.image,
        30
      )}" data-src="${getImage(item.image, 250)}">`;
    }

    let cartItem = miniCartItem;
    
    if (cartItem) {
      cartItem = cartItem.replace(/{{itemImage}}/g, buildImage(item));
      cartItem = cartItem.replace(/{{itemProductId}}/g, item.product_id);
      cartItem = cartItem.replace(/{{itemVariantId}}/g, item.id);
      cartItem = cartItem.replace(/{{itemTitle}}/g, item.product_title);
      
      // Format final price without trailing zeroes
      cartItem = cartItem.replace(/{{itemFinalPrice}}/g, 
        this.moneyFormat(item.final_line_price).replace(/\.00$/, "")
      );
      
      if (item.price == 0) {
        item.url = 'javascript:;';
      }
      
      cartItem = cartItem.replace(/{{itemUrl}}/g, item.url);
      
      // Format compare price without trailing zeroes
      cartItem = cartItem.replace(
        /{{itemComparePrice}}/g,
        CompareAtPrice(item) > item.price
          ? this.moneyFormat(CompareAtPrice(item)).replace(/\.00$/, "")
          : ""
      );
      
      if (item.price == 0) {
        cartItem = cartItem.replace(/{{itemPrice}}/g, 'Free');
      } else {
        // Format item price without trailing zeroes
        cartItem = cartItem.replace(
          /{{itemPrice}}/g,
          this.moneyFormat(item.price).replace(/\.00$/, "")
        );
      }
      
      cartItem = cartItem.replace(/{{itemOptions}}/g, buildOptions(item));
      cartItem = cartItem.replace(/{{itemProps}}/g, buildProps(item));
      cartItem = cartItem.replace(/{{itemQuantity}}/g, item.quantity);
    }
    return cartItem;
  }

  hideOnEscape(e) {
    var keyCode = e.keyCode;
    if (keyCode === 27 && this.minicart) {
      this.minicart.classList.remove("open");
      this.minicart.classList.add("close");
    }
  }

  moneyFormat(amout, customCurrency = "€") {
    if (!amout) return "";
    if (typeof theme.Shopify.formatMoney === "function") {
      // const currency = theme.Shopify.money_format.split("{")[0];
      // OLD LINE
//       return Shopify.formatMoney(amout, `{{amount_with_comma_separator}} ${currency}`);
      return theme.Shopify.formatMoney(amout, theme.money_format);
    } else {
      const currency = customCurrency;
      return `${currency}${amout / 100}`;
    }
  }

  findAncestor(el, sel) {
    while (
      (el = el.parentElement) &&
      !(el.matches || el.matchesSelector).call(el, sel)
    );
    return el;
  }
}

const mini_cart = new MiniCart();

// Assign mini_cart variable to global usage
window.mini_cart = mini_cart;

// Init Cart Items
mini_cart.updateCart(false);

// Hide MiniCart on Escape keydown
document.addEventListener("keydown", function (e) {
  mini_cart.hideOnEscape(e);
});

// MiniCart Events
document.addEventListener("click", function (e) {
  mini_cart.removeCartItem(e.target);
  mini_cart.plusCartItem(e.target);
  mini_cart.minusCartItem(e.target);
  mini_cart.closeCart(e.target);
});
const minicartOpenButtons = document.querySelectorAll('.open-minicart');
minicartOpenButtons.forEach(function(button) {
  button.addEventListener('click', function(e) {
    console.log('testtttt');
    mini_cart.openCart(button);
  });
});
$('body').click((e) => {
  const target = $(e.target);
  if ( target.attr('class') == 'pw-switch' ) {
      setTimeout(function () {
        fetch('/cart.js')
          .then((resp) => resp.json())
          .then((cart) => {
            if (cart) {
              if ( target.attr('data-toggle') == 'true' ) {
                mini_cart.updateCart(true);
              } else {
                mini_cart.updateCart(true);
              }
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }, 1000);
    }
});